import { render, staticRenderFns } from "./Timeslot.vue?vue&type=template&id=80a1008a&scoped=true&"
import script from "./Timeslot.vue?vue&type=script&lang=js&"
export * from "./Timeslot.vue?vue&type=script&lang=js&"
import style0 from "./Timeslot.vue?vue&type=style&index=0&id=80a1008a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a1008a",
  null
  
)

export default component.exports